function Readingmask()
{
 $('html').mousemove(function(event) {
            var windowHeight = $(window).height();
            var mouseY = event.clientY;
            var topMaskHeight = mouseY;
            var bottomMaskHeight = windowHeight - mouseY;
	    topMaskHeight=topMaskHeight-60;
	    bottomMaskHeight=bottomMaskHeight-60;
            $('.app-reading-mask-top').css('height', topMaskHeight+'px');
            $('.app-reading-mask-bottom').css('height', bottomMaskHeight+'px');
        });
}
function getreadline()
{
 var $guide = $('.app-reading-guide');
    $('html').mousemove(function(event) {
        var containerOffset = $(this).offset();
        var relativeY = event.pageY - containerOffset.top;
        
        $guide.css({
            top: relativeY + 'px'
        });
    });
    $('html').hover(
        function() {
            $guide.show();
        },
        function() {
            $guide.hide();
        }
    );
}
 function saveSettings() {
  localStorage.setItem('biggerText', $('body').hasClass('bigger-text-app'));
    localStorage.setItem('biggerCursor', $('body').hasClass('bigger-cursor-data'));
	if ($('.acess-button.toggle-tooltip.app-active-item').length > 0)
 {
   localStorage.setItem('tooltipData', "true");
   }
   else
   {
      localStorage.setItem('tooltipData', "false");
   }
	localStorage.setItem('lineheight', $('body').hasClass('line-height-app'));
	localStorage.setItem('invertHtml', $('html').hasClass('invert-html-app'));
    localStorage.setItem('brightnessHtml', $('html').hasClass('brightness-html-app'));
    localStorage.setItem('contrastHtml', $('html').hasClass('contrast-html-app'));
    localStorage.setItem('grayscaleHtml', $('html').hasClass('grayscale-html-app'));
    localStorage.setItem('saturateHtml', $('html').hasClass('saturate-html-app'));
    localStorage.setItem('highlightLinks', $('a').hasClass('heighlight-link-app'));
	
    localStorage.setItem('activeButtons', JSON.stringify(
      $('.acess-button').map(function() {
        return $(this).hasClass('app-active-item');
      }).get()
    ));
  }


   function loadSettings() {
      if (localStorage.getItem('biggerText') === 'true') 
      {
       
       // alert("OK");
      }
    if (localStorage.getItem('biggerCursor') === 'true') $('body').addClass('bigger-cursor-data');
    if (localStorage.getItem('tooltipData') === 'true')$('.tooltip-appdata').addClass('tooltipdata');
	 if (localStorage.getItem('lineheight') === 'true') $('body').addClass('line-height-app');
    if (localStorage.getItem('invertHtml') === 'true') $('html').addClass('invert-html-app');
    if (localStorage.getItem('brightnessHtml') === 'true') $('html').addClass('brightness-html-app');
    if (localStorage.getItem('contrastHtml') === 'true') $('html').addClass('contrast-html-app');
    if (localStorage.getItem('grayscaleHtml') === 'true') $('html').addClass('grayscale-html-app');
    if (localStorage.getItem('saturateHtml') === 'true') $('html').addClass('saturate-html-app');
    if (localStorage.getItem('highlightLinks') === 'true') $('a').addClass('heighlight-link-app');
         const activeButtons = JSON.parse(localStorage.getItem('activeButtons'));
    if (activeButtons) {
      $('.acess-button').each(function(index) {
        if (activeButtons[index]) {
          $(this).addClass('app-active-item');
         if($(this).text().trim()=="Line Height")
             $(this).addClass('myselectedicons');
          if($(this).text().trim()=="Invert Color")
             $(this).addClass('myselectedicons');
        
              if($(this).text().trim()=="Read Page")
             $(this).addClass('myselectedicons');
              
            
        }
      });
    }

     if ($('button.acess-button.hide-image-app-button.app-active-item').length > 0)$("img").hide(); else $("img").show();

     		if ($('button.acess-button.stop-animation-app.app-active-item').length > 0)
		 {
		document.getAnimations().forEach(
animation =>{
animation.pause();
});
		 }
		 else
		 {
		document.getAnimations().forEach(
animation =>{
animation.play();
});
		 }

      if ($('button.acess-button.Read-Guide-Line.app-active-item').length > 0)
		 {
		 $(".myreadline-app").addClass("app-reading-guide");
		 getreadline();
		 }
     if ($('button.acess-button.reading-mask-app-button.app-active-item').length > 0)
		 {
		$(".reading-mask-app").addClass("reading-mask");
		Readingmask();
		}

     		 if ($('button.acess-button.read-audio.app-active-item').length > 0)
		 {
		   ReadAudio();
		 }
		 else
		 {
		   Stopaudio();
		 }
      if ($('button.acess-button.bigertext.app-active-item').length > 0)
		 {
            $('p, li, div, a, table, span').addClass('bigger-text-app');
         }
   }
  function getSelectedText() {
        if (window.getSelection) {
            return window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            return document.selection.createRange().text;
        }
        return '';
    }
	
	function ReadAudio()
	{
	 $('html').on('mouseup touchstart', function() {
  
 var  text = window.getSelection().toString();
       if(text)
	   {
	     $("body").toggleClass('highlight-selection');
	    var selection = window.getSelection();
                if (selection.rangeCount > 0) {
                    var range = selection.getRangeAt(0);
                    var span = document.createElement('span');
                    //span.style.backgroundColor = 'yellow';
					span.classList.add('highlight-data');
                    range.surroundContents(span);
                }
	   let utterance = new SpeechSynthesisUtterance(text);
       utterance.onend = function() {
	    span.outerHTML = span.innerHTML;
                    window.getSelection().empty();
         window.speechSynthesis.cancel();
         $('span.highlight-data').removeClass('highlight-data');
                };
			 window.speechSynthesis.speak(utterance);
			 text="";
			 }
			
    });
	}
	function Stopaudio()
	{
	window.speechSynthesis.cancel();
window.getSelection().empty();
 $('html').unbind();
 $("body").toggleClass('highlight-selection');
$('span.highlight-data').removeClass('highlight-data');
	}
	

 
$(document).ready(function(){
loadSettings();
 getreadline();
 // Readingmask();
  $('img').hover(
        function(event) {
                const altText = $(this).attr('alt');
                $('.tooltipdata').text(altText).css({
                    top: event.pageY + 10 + 'px',
                    left: event.pageX + 10 + 'px'
                }).show();
           
        },
        function() {
            $('.tooltipdata').hide();
        }
    );
    $('img').mousemove(function(event) {
            $('.tooltipdata').css({
                top: event.pageY + 10 + 'px',
                left: event.pageX + 10 + 'px'
            });
        
    });
});

	 